// extracted by mini-css-extract-plugin
export default {"sectionButtons":"styles_sectionButtons__X9k6C","sectionButton":"styles_sectionButton__4vKLd"};